module.exports = __webpack_public_path__ + "2698d6d4ecc4ec9a441f42a74afcbd4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/history/7.jpg
// module id = 307
// module chunks = 0